import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { finalize, Observable } from 'rxjs';
import { LoaderService } from '../services/loader.service';

const APIS_WITH_SKIPPED_LOADING: string[] = ['/api/v1/user-management/search', '/api/v1/dropdown-configurations/search-entry'];

@Injectable({
  providedIn: 'root',
})
export class HttpLoadingInterceptor implements HttpInterceptor {
  activeRequests: number = 0;  

  constructor(private loader: LoaderService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {   
    if (APIS_WITH_SKIPPED_LOADING.some((api: string) => request.url.includes(api))) {
      return next.handle(request);
    } else {
      this.activeRequests++;
      if (this.activeRequests === 1) {
        // Start the loader only for the first active request
        this.loader.start();
      }

      return next.handle(request).pipe(
        finalize(() => this.decrementActiveRequests())
      );
    }
  }

  decrementActiveRequests() {
    this.activeRequests--;
    if (!this.activeRequests) {
      // Complete the loader when no requests are active
      this.loader.stop();
    }
  }
}
